import SimpleTooltip from "../../SimpleTooltip";
import TemplateView from "../../TemplateView";
import {TaskManagementViewMode} from "../constants"

export default class ViewModeSelector extends TemplateView {
    constructor({
        onModeSelected = mode => {}
    }) {
        super()

        this.onModeSelected = onModeSelected

        this.state = {
            viewMode: null
        }

        this.onStatePropertyChanged('viewMode', viewMode => this._updateViewMode(viewMode))
    }

    templateHtml() {
        return "<div class='viewModeSelector'>" +
               "  <div class='modeButton table'></div>" +
               "  <div class='modeButton kanban'></div>" +
               "</div>"
    }

    afterRender() {
        this.$tableButton = this.find(".modeButton.table").click(() => this.onModeSelected(TaskManagementViewMode.TABLE))
        this.$kanbanButton = this.find(".modeButton.kanban").click(() => this.onModeSelected(TaskManagementViewMode.KANBAN))

        this.tooltip = new SimpleTooltip().init($('body'))
        this.tooltip.subscribeToMouseEvents(
            this.find(".modeButton.table"),
            () => this.tooltip.setText(messageResource.getMessage("task.list.view_mode.list"))
        )
        this.tooltip.subscribeToMouseEvents(
            this.find(".modeButton.kanban"),
            () => this.tooltip.setText(messageResource.getMessage("task.list.view_mode.kanban"))
        )
    }

    _updateViewMode(viewMode) {
        this.$tableButton.toggleClass('active', viewMode === TaskManagementViewMode.TABLE)
        this.$kanbanButton.toggleClass('active', viewMode === TaskManagementViewMode.KANBAN)
    }
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/header/ViewModeSelector.js